import React from "react";
import { func } from "prop-types";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";

import "../Organisations/AddOrganization.less";
import "../../App/App.less";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

class SettingDeleteConfirmationModal extends React.Component {

  constructor() {
    super();
  }

  componentWillUnmount() {
    this.disableDeleteBtn(false);
  }

  disableDeleteBtn = (value) => {
    let deleteBtn = document.getElementById("settingDeleteConfirmationModalDeleteBtn");
    if(deleteBtn){
      deleteBtn.disabled = value;
      if(value)
        deleteBtn.classList.add("pointerEventsNone");
      else
        deleteBtn.classList.remove("pointerEventsNone");
    }
  }

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        <Button
          className="buttons borderBtn bgwhite"
          onClick={() => this.props.handleCancelClick()}
        >
          {getMessage("CANCEL")}
        </Button>
        <Button
          onClick={() => {
            this.disableDeleteBtn(true);
            this.props.handleDeleteClick(this.props.parameter);
          }
          }
          id="settingDeleteConfirmationModalDeleteBtn"
          className="buttons borderBtn customBtn resetButton whiteOnClick"
          autoFocus
        >
          {getMessage("DELETE")}
        </Button>
      </div>
    );
  };

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="settingDeleteConfirmationModal"
        toggle={this.props.handleCancelClick}
        backdrop="static"
      >
        <ModalBody>
          {getMessage("DELETE_MSG",
            {deleteTarget: (this.props.deleteTarget)})}
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>
    );
  }
}

export default modalScrollBar(SettingDeleteConfirmationModal);
